import dayjs from 'dayjs';
import { store } from '../index';



export const validateName = values => {
    let errors;
    if (!values) {
      errors = 'Name is required';
    } else if (values.length < 2) {
      errors = 'Name is too short';
    } else if(values === 'admin' || values === 'null' || values === 'god'){
      errors = 'Nice try ;)';
    }
    return errors;
  }

  export const validateSurname = values => {
    let errors;
    if (!values) {
      errors = 'Surname is required';
    } else if (values.length < 2) {
      errors = 'Surname is too short';
    } 
    return errors;
  }  

  export const validateEmail = values => {
    let errors;
    if (!values) {
        errors = 'Email address is required';
    } else if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(values)) {
        errors = 'Invalid email address';
    }
    return errors;
}

export const validatePassword = values => {
    let errors;
    if (!values) {
        errors = 'Password is required';
    } else if (values.length < 5) {
        errors = 'Password is too short';
    }
    return errors;
}


export const validateDob = values => {

  let errors;
  const departureDate = store.getState().currentBooking !== undefined ? store.getState().currentBooking.items[0].date : dayjs();

  if(!values){
    errors = "Date of birth is required";
  }else if(!/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/.test(values)){
    errors = "Date of birth invalid";
  }else if(dayjs(departureDate).diff(values.split("/").reverse().join("-"), 'years', true) < 18 ){
    errors = "Passenger must be aged 18 years and over";
  }

  return errors;
}


export const validateTelephone = values => {
  let errors;

  if(!values){
    errors = 'Phone number is required';
  }
  return errors;
}


export const validateEmergencyTelephone = values => {
  let errors;

  if(!values){
    errors = 'Phone number is required';
  }
  return errors;
}

export const validateRequired = values => {
  let errors;

  if(!values){
    errors = 'Required';
  }
  return errors;
}


export const validateGender = values => {
  let errors;

  if(!values){
    errors = 'Gender is required';
  }
  return errors;
}